import { Router } from '@angular/router';
import { AuthService } from './auth.service';
var LoginGuard = /** @class */ (function () {
    function LoginGuard(auth, router) {
        this.auth = auth;
        this.router = router;
    }
    LoginGuard.prototype.canActivate = function () {
        if (this.auth.loggedIn()) {
            this.router.navigate(['/freelancers']);
        }
        return true;
    };
    return LoginGuard;
}());
export { LoginGuard };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/login-guard.service.ts.pre-build-optimizer.js